export const UPDATE_AMOUNT_INVESTMENT_ATTEMPT = 'UPDATE_AMOUNT_INVESTMENT_ATTEMPT';
export type UPDATE_AMOUNT_INVESTMENT_ATTEMPT = typeof UPDATE_AMOUNT_INVESTMENT_ATTEMPT;

export const UPDATE_AMOUNT_INVESTMENT_SUCCESS = 'UPDATE_AMOUNT_INVESTMENT_SUCCESS';
export type UPDATE_AMOUNT_INVESTMENT_SUCCESS = typeof UPDATE_AMOUNT_INVESTMENT_SUCCESS;

export const UPDATE_AMOUNT_INVESTMENT_FAILURE = 'UPDATE_AMOUNT_INVESTMENT_FAILURE';
export type UPDATE_AMOUNT_INVESTMENT_FAILURE = typeof UPDATE_AMOUNT_INVESTMENT_FAILURE;



// WEBPACK FOOTER //
// ./src/actions/update-amount/Types.tsx